import { FC } from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import DecorativeImage from 'components/DecorativeImage';

import ButtonRow from '../components/ButtonRow';
import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import accountingExportImg from '../images/accounting-export-1.svg';
import locales from './locales';

const AccountingExport: FC = () => (
  <Wrapper>
    <DecorativeImage src={accountingExportImg} />
    <Title>{locales.title}</Title>
    <Text size="sm">{locales.body}</Text>
    <ButtonRow>
      <Button
        as={Link}
        to="/accounting/exports/new/one-off"
        variant="inline-primary"
      >
        {locales.goToExplanation}
      </Button>
      <Button
        as={Link}
        icon="arrow-right"
        iconPosition="right"
        to="/company/account-closure/reasons"
      >
        {locales.next}
      </Button>
    </ButtonRow>
  </Wrapper>
);

export default AccountingExport;
